<template>
  <div class="card-ticket-module">
    <div class="cardList">
      <el-menu default-active="/home/card-ticket-grantDetails" class="card-menu" mode="horizontal" @select="handleSelect">
        <el-menu-item index="/home/card-ticket-module">卡券模板</el-menu-item>
        <el-menu-item index="/home/card-ticket-grantDetails">发放明细</el-menu-item>
        <el-menu-item index="/home/card-ticket-hxoff">核销明细</el-menu-item>
      </el-menu>
    </div>
    <div class="sxList">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchData">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide" class="search-flod-content search-content search-input-group common-search-formtype grantDetails" style="padding: 0;border: none">
          <el-form :inline="true" :model="selectList" class="search-content-item">
            <el-form-item label="券码：">
              <el-input clearable @keyup.enter.native="searchData" v-model.trim="selectList.code" placeholder="请输入券码"></el-input>
            </el-form-item>
            <el-form-item label="模板名称：">
              <el-input clearable @keyup.enter.native="searchData" v-model.trim="selectList.templateName" placeholder="请输入模板名称"></el-input>
            </el-form-item>
            <el-form-item label="卡券类型：">
              <el-select filterable v-model="selectList.ticketType" placeholder="请选择卡券类型">
                <el-option v-for="item in cardticketType" :key="item.value" :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发券系统：">
              <el-select filterable v-model="systemName" placeholder="请选择发券系统">
                <el-option v-for="item in systemList" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态：">
              <el-select filterable v-model="statusVal" placeholder="请选择状态">
                <el-option v-for="item in statuses" :key="item.value" :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="持有人/openid：">
              <el-input clearable @keyup.enter.native="searchData" v-model.trim="selectList.holder" placeholder="请输入昵称/openid"></el-input>
            </el-form-item>
            <div class="djList">
              <el-form-item label="领券时间：">
                <el-date-picker v-model="selectList.receiveTime" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" @change="timeFormat">
                </el-date-picker>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <div class="cardTicketModule-list-tltle">
      <el-row class="" style="padding-right:0">
        <el-col :span="4" style="text-align: left;padding-left: 20px;">
          <i class="el-icon-document" style="font-weight: bold;"></i>
          <span class="order-list-search-span">发放列表</span>
        </el-col>
        <el-col :span="20" class="text-align-right">
          <el-button type="primary" v-show="btnType.export" @click="addOfflineAcivityAction" class="add-btn btn-right" style="float: right;">导出</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="cardTicketModule-list">
      <!-- v-loading="loadList" -->
      <el-table class="cardTicketModule-table" :data="tableData" border v-loading="loading">
        <el-table-column prop="code" label="券码" width="180">
        </el-table-column>
        <el-table-column prop="templateName" label="模板名称" width="160">
        </el-table-column>
        <el-table-column label="卡券类型" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.ticketType == 1">实物兑换券</div>
            <div v-if="scope.row.ticketType == 2">活动券</div>
            <div v-if="scope.row.ticketType == 3">代金券</div>
          </template>
        </el-table-column>
        <el-table-column prop="grantSystemName" label="发券系统" width="120">
        </el-table-column>
        <el-table-column prop="holderModelName" label="受众类型" width="100">
        </el-table-column>
        <el-table-column prop="holder" label="持有人" width="130">
        </el-table-column>
        <el-table-column prop="openid" label="openid" width="180">
        </el-table-column>
        <el-table-column prop="receiveTimeStr" :sortable="isSort" label="领券时间" width="190">
        </el-table-column>
        <el-table-column prop="verifiedTimeStr" :sortable="isSort" label="核销时间" width="150">
        </el-table-column>
        <el-table-column prop="vouchersAmount" label="面值(元)" :sortable="isSort" width="100">
        </el-table-column>
        <el-table-column prop="state" label="状态" width="100">
        </el-table-column>
        <el-table-column class="aud-operatopn-div" fixed="right" label="操作">
          <template slot-scope="scope">
            <div class="op-link" v-if="scope.row.state == '未核销'">
              <span class="op-link" @click="toAudDetail(scope.row)" v-show="btnType.verif" size="small">核销</span>
            </div>
            <div class="op-link" v-else>
              <span class="op-link" size="small"></span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="cardTicket-page">
        <el-pagination class="cardTicket-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="mxParams.limit" :current-page="mxParams.page" layout="total, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="核销确认" :visible.sync="dialogVisible" width="30%">
      <el-form>
        <el-form-item label="核销时间">
          <el-date-picker v-model="hxDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" @change="hxTimes">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="jgInfo">
        <i class="el-icon-warning"></i> 一经核销，券会变更为已核销状态，不能再次使用</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitHx">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { grantInfoPage, grantSystemList, grantInfoExport, verifiedSubmit } from '@/api/cardTicket.js'
import { CAR_TICKET_TYPE } from './constant'
import { butonsList,getMenId } from '@/api/analyse.js'
export default {
  name: 'cardTicketModule',
  data () {
    return {
      date2: '',
      dialogVisible: false,
      hide: true,
      systemName: '',
      systemList: [],
      statusVal: '',
      cardticketType: CAR_TICKET_TYPE,
      statuses: [{
        value: 4,
        name: '全部'
      }, {
        value: 0,
        name: '已过期'
      }, {
        value: 1,
        name: '已核销'
      }, {
        value: 2,
        name: '未核销'
      }],
      mxParams: {
        code: '',
        templateName: '',
        grantSystemCode: '',
        holder: '',
        receiveTimeStart: '',
        receiveTimeEnd: '',
        queryState: '',
        page: 1,
        limit: 10,
        sortCode: '',
        sortRole: ''
      },
      selectList: {},
      systems: [],
      timePickerDate: '',
      loadList: true,
      tableData: [],
      isSort: true,
      limit: 10,//每页显示的条数
      page: 1,//当前页数
      totalCount: 0,//总条目数
      cardName: '',
      dynamicValidateForm: {
        domains: [{
          value: ''
        }],
      },
      hxDate: '',
      hxParams: {
        id: '',
        verifiedTime: ''
      },
      loading: true,
      btnType:{
        'export':false,
        'verif':false
      }
    }
  },
  methods: {
    getdatatime () {
      // this.hxDate = new Date()
      var date = new Date()
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      var d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      var h = date.getHours()
      h = h < 10 ? ('0' + h) : h
      var minute = date.getMinutes()
      var second = date.getSeconds()
      minute = minute < 10 ? ('0' + minute) : minute
      second = second < 10 ? ('0' + second) : second
      this.hxDate = y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
    },
    queryBtnList(){
      var itemId = getMenId(this.$route.path)
       butonsList({systemCode: 'ZY_INTELLIQUOR',menuId:38})
        .then((res)=>{
          if(res.data.code == '200'){
            var btnList = this.btnType
            for(let i = 0, k = res.data.result.length; i < k; i ++){
              for(let m in btnList){
                if(res.data.result[i].perms.indexOf(m) != -1){
                  this.btnType[m] = true
                }
              }
            }
          }
        })
    },
    // 领券时间选择
    timeFormat (val) {
      if (val != undefined || val != '') {
        this.mxParams.receiveTimeStart = this.selectList.receiveTime[0]
        this.mxParams.receiveTimeEnd = this.selectList.receiveTime[1]
      }
    },
    // 查询发放系统
    grantSystemList () {
      grantSystemList().then(res => {
        this.systemList.push({
          code: 'CLOUD_all',
          companyId: 0,
          id: 0,
          name: '全部',
          relModelId: 0,
          remark: '全部'
        })
        for (let i of res.data.result) {
          this.systemList.push(i)
        }
      })
    },
    // 查询
    searchData () {
      this.mxParams.code = this.selectList.code
      this.mxParams.templateName = this.selectList.templateName
      this.mxParams.templateName = this.selectList.templateName
      this.mxParams.ticketType = this.selectList.ticketType
      this.mxParams.grantSystemCode = this.systemName
      if (this.selectList.receiveTime == null) {
        this.mxParams.receiveTimeStart = ''
        this.mxParams.receiveTimeEnd = ''
      }
      if (this.statusVal == 4) {
        this.mxParams.queryState = ''
      } else {
        this.mxParams.queryState = this.statusVal
      }
      this.mxParams.holder = this.selectList.holder
      if (this.selectList.ticketType == 0) {
        this.mxParams.ticketType = ''
      }
      if (this.systemName == 'CLOUD_all') {
        this.mxParams.grantSystemCode = ''
      }
      this.getData()
    },
    // 发放明细列表
    getData () {
      this.loading = true
      grantInfoPage(this.mxParams).then(res => {
        this.tableData = res.data.result.list
        console.log(res.data.result.list)
        this.totalCount = res.data.result.total
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading () {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 表格导出
    addOfflineAcivityAction () {
      grantInfoExport(this.mxParams).then(res => {
        this.download(res)
      })
    },
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    handleSelect (key, keyPath) {
      router.push(key)
    },
    // 处理分页
    handleSizeChange (val) {
      this.mxParams.limit = val
    },
    handleCurrentChange (page) {
      this.mxParams.page = page
      this.getData()
    },
    hxTimes (val) {
      this.hxDate = val
    },
    toAudDetail (val) {
      this.getdatatime()
      this.dialogVisible = true
      this.hxParams.id = val.id
    },
    submitHx () {
      if (this.hxDate != '' && this.hxDate != null) {
        this.hxParams.verifiedTime = this.hxDate.replace(' ', 'T')
      } else {
        _g.toastMsg('error', '请填写核销时间！')
        return
      }
      verifiedSubmit(this.hxParams).then(res => {
        if (res.data.code === '200') {
          _g.toastMsg('success', res.data.message)
          this.dialogVisible = false
          this.getData()
        }
      })
    }
  },
  created () {
    this.getdatatime()
    if (this.$route.query.ticketName && this.$route.query.templateId) {
      this.mxParams.templateName = this.$route.query.ticketName
      this.selectList.templateName = this.$route.query.ticketName
      this.getData()
    } else {
      this.getData()
    }
    this.grantSystemList()
    this.queryBtnList()
  }
}
</script>

<style scoped>
.jgInfo {
  text-align: left;
  width: 75%;
  margin: -9px 27% 0 27%;
  font-size: 12px;
}
.jgInfo i {
  color: #f96b6b;
}
</style>
